import React, { useState } from 'react';
import request from 'superagent'
import validator from 'validator'
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Snackbar, SnackbarContent, TextField, styled, useMediaQuery, useTheme } from '@mui/material';
import { CheckCircleOutline, Close } from '@mui/icons-material';
import { green, red } from '@mui/material/colors';
import { LoadingButton } from '@mui/lab';

const SuccessSnackBarIcon = styled(CheckCircleOutline)(({ theme }) => ({
  fontSize: 20,
  opacity: 0.9,
  marginRight: theme.spacing(1),
}));

const ErrorSnackBarIcon = styled(Close)(({ theme }) => ({
  fontSize: 20,
  opacity: 0.9,
  marginRight: theme.spacing(1),
}));

/*const sublocations = [
  { title: 'Schemmerhofen', sublocation: 'Schemmerhofen' },
  { title: 'Schemmerberg', sublocation: 'Schemmerberg' },
  { title: 'Ingerkingen', sublocation: 'Ingerkingen' },
  { title: 'Aßmannshardt', sublocation: 'Aßmannshardt' },
  { title: 'Alberweiler', sublocation: 'Alberweiler' },
  { title: 'Altheim', sublocation: 'Altheim' }
];*/

const sublocations = [
  'Schemmerhofen',
  'Schemmerberg',
  'Ingerkingen',
  'Aßmannshardt',
  'Alberweiler',
  'Altheim'
];

const categories = [
  'Kategorie I - Traditionell einjähriger Blumenschmuck',
  'Kategorie II - Mehrjähriger Blumenschmuck',
];

export default function Form() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState(false);
  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState(false);
  const [street, setStreet] = useState("");
  const [errorStreet, setErrorStreet] = useState(false);
  const [houseNumber, setHouseNumber] = useState("");
  const [errorHouseNumber, setErrorHouseNumber] = useState(false);
  const [sublocation, setSublocation] = useState(null);
  const [errorSublocation, setErrorSublocation] = useState(false);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [category, setCategory] = useState(null);
  const [errorCategory, setErrorCategory] = useState(false);
  const [locationDescription, setLocationDescription] = useState("");
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);

  const resetForm = () => {
    //Formular zurücksetzen
    setFirstName("");
    setLastName("");
    setStreet("");
    setHouseNumber("");
    setSublocation("");
    setEmail("");
    setCategory(null);
    setLocationDescription("");
    setLoading(false);
  }

  const handleSnackbarClose = () => {
    setSuccessSnackbarOpen(false);
    setErrorSnackbarOpen(false);
  }

  const send = () => {
    if (firstName !== "" && lastName !== "" && street !== "" && houseNumber !== "" && sublocation !== "" && email !== "" && validator.isEmail(email)) {
      setLoading(true);

      const categoryAsNumber = category === categories[0] ? 1 : 2;

      request.post('https://formulare-schemmerhofen.de/blumen/backend.php')
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send({
          command: "newregistration",
          first_name: firstName,
          last_name: lastName,
          street: street,
          house_number: houseNumber,
          sublocation: sublocation,
          email: email,
          category: categoryAsNumber,
          location_description: locationDescription
        })
        .end((_, res) => {
          const result = res.text.trim();
          if (result === "1") {
            setSuccessSnackbarOpen(true);
            resetForm();
          } else {
            setLoading(false);
            setErrorSnackbarOpen(true);
          }
        });
    } else {
      setErrorFirstName(firstName === "");
      setErrorLastName(lastName === "");
      setErrorStreet(street === "");
      setErrorHouseNumber(houseNumber === "");
      setErrorSublocation(sublocation === null);
      setErrorEmail(email === "" || !validator.isEmail(email));
      setErrorCategory(category === null);
    }
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
    setErrorFirstName(false);
  }

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
    setErrorLastName(false);
  }

  const handleStreetChange = (event) => {
    setStreet(event.target.value);
    setErrorStreet(false);
  }

  const handleHouseNumberChange = (event) => {
    setHouseNumber(event.target.value);
    setErrorHouseNumber(false);
  }

  const handleSublocationChange = (_, newValue) => {
    setSublocation(newValue);
    setErrorSublocation(false);
  }

  const handleCategoryChange = (_, newValue) => {
    setCategory(newValue);
    setErrorCategory(false);
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setErrorEmail(false);
  }

  const handleLocationDescriptionChange = (event) => {
    setLocationDescription(event.target.value);
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open
      aria-labelledby="responsive-dialog-title"
      BackdropProps={{ style: { backgroundColor: "transparent" } }}>
      <DialogTitle id="responsive-dialog-title">
        Anmeldung Blumenschmuckwettbewerb
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Bitte füllen Sie das Formular unten aus um sich für den Blumenschmuckwettbewerb anzumelden.
        </DialogContentText>
        {/* Vorname */}
        <TextField
          label="Vorname"
          value={firstName}
          onChange={handleFirstNameChange}
          style={{ width: "49%", marginRight: "2%", marginTop: 10 }}
          error={errorFirstName}
          inputProps={{ maxLength: 30 }}
          required />
        {/* Nachname */}
        <TextField
          label="Nachname"
          value={lastName}
          onChange={handleLastNameChange}
          style={{ width: "49%", marginTop: 10 }}
          error={errorLastName}
          inputProps={{ maxLength: 30 }}
          required />
        {/* Straße */}
        <TextField
          label="Straße"
          value={street}
          onChange={handleStreetChange}
          style={{ width: "69%", marginRight: "2%", marginTop: 10 }}
          error={errorStreet}
          inputProps={{ maxLength: 50 }}
          required />
        {/* Hausnummer */}
        <TextField
          label="Hausnummer"
          value={houseNumber}
          onChange={handleHouseNumberChange}
          style={{ width: "29%", marginTop: 10 }}
          error={errorHouseNumber}
          inputProps={{ maxLength: 10 }}
          required />
        {/* Teilort */}
        <Autocomplete
          options={sublocations}
          value={sublocation}
          onChange={handleSublocationChange}
          style={{ width: "40%", marginRight: "2%", marginTop: 10 }}
          renderInput={(params) =>
            <TextField
              {...params}
              label="Teilort"
              error={errorSublocation}
              required />
          } />
        {/* E-Mail */}
        <TextField
          label="E-Mail Adresse"
          value={email}
          onChange={handleEmailChange}
          style={{ width: "49%", marginTop: 10 }}
          error={errorEmail}
          inputProps={{ maxLength: 100 }}
          required />
        {/* Kategorie */}
        <Autocomplete
          options={categories}
          value={category}
          onChange={handleCategoryChange}
          style={{ width: "100%", marginTop: 10 }}
          renderInput={(params) =>
            <TextField
              {...params}
              label="Kategorie"
              error={errorCategory}
              required />
          } />
        {/* Lokationsbeschreibung */}
        <TextField
          label="Lage auf dem Grundstück"
          value={locationDescription}
          onChange={handleLocationDescriptionChange}
          margin="dense"
          style={{ width: "100%", marginTop: 10 }}
          inputProps={{ maxLength: 500 }} />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={resetForm}
          variant="contained"
          disabled={loading}>
          Formular zurücksetzen
        </Button>
        <LoadingButton
          onClick={send}
          variant="contained"
          loading={loading}
          color="primary">
          Anmeldung speichern
        </LoadingButton>
      </DialogActions>

      {/* Snackbars */}
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={successSnackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <SnackbarContent
          message={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <SuccessSnackBarIcon />
              Ihre Anmeldung wurde erfolgreich gespeichert
            </span>
          }
          action={[
            <IconButton color="inherit" onClick={handleSnackbarClose}>
              <Close style={{ fontSize: 20 }} />
            </IconButton>,
          ]}
          style={{ backgroundColor: green[600] }} />
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={errorSnackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <SnackbarContent
          message={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <ErrorSnackBarIcon />
              Ihre Anmeldung ist bereits vorhanden oder es gab einen Fehler
            </span>
          }
          action={[
            <IconButton color="inherit" onClick={handleSnackbarClose}>
              <Close style={{ fontSize: 20 }} />
            </IconButton>,
          ]}
          style={{ backgroundColor: red[600] }} />
      </Snackbar>
    </Dialog>
  );
}
